import React from 'react';

const ArrowIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      {...props}
    >
      <path
        fill="#533019"
        d="M13.797 28.262l10.187-8.785L13.797 6.734 11.02 8.301l7.023 11.187-7.023 7.164zm0 0"
      ></path>
    </svg>
  );
};

export default ArrowIcon;
